module.exports = __webpack_public_path__ + "img/c29268e.jpg";